import { PAGE_SIZE } from '@/constants'
import { buildQuery } from '@/utils/helpers'
import fetcher, { fetchWithToken } from '../fetcher'
import type { ICreateReviewInput, ICreateReviewResponse } from '@/features/products/types/review'

export const GET_LIST_PRODUCTS = `
query getProducts(
    $search: String
    $filter: ProductAttributeFilterInput
    $sort: ProductAttributeSortInput
    $pageSize: Int
    $currentPage: Int
  ) {
    products(
      search: $search
      filter: $filter
      sort: $sort
      pageSize: $pageSize
      currentPage: $currentPage
    ) {
      items {
        ...ProductInterfaceField
        ...ConfigurableProductField
      }
      aggregations{
        attribute_code
        count
        label
        options {
          count
          label
          value
          swatch_data {
            type
            value
          }
        }
        
        position
      }
      sort_fields {
        default
        options {
          label
          value
        }
      }
      total_count
      priceRangeFilters {
        max
        min
        ranges {
          from
          label
          to
          value
        }
      }
      page_info {
        current_page
        page_size
        total_pages
      }
      
    }
  }
  fragment ProductInterfaceField on ProductInterface {
    __typename
    sku
    uid
    name
    url_key
    url_suffix
    canonical_url
    stock_status
    categories {
      __typename
      name
      url_key
      url_path
      level
      uid
      icon_image
      image
      path
    }
    meta_description
    meta_keyword
    meta_title
    new_from_date
    new_to_date
    rating_summary
    review_count
    thumbnail {
      url
      position
    }
    image {
      url
    }
    media_gallery {
      __typename
      disabled
      label
      url
      position
    }
    price_range {
      ...PriceRangeField
    }
    ...CustomField
  }
  fragment CustomField on ProductInterface {
    color
   
    country_of_manufacture
    daily_sale {
      end_date
      entity_id
      sale_price
      sale_qty
      saleable_qty
      sold_qty
      start_date
      __typename
    }
    rating_summary_start {
      star_1
      star_2
      star_3
      star_4
      star_5
    }
    attributes {
      attribute_code
      label
      value
    }
  }
  fragment ConfigurableProductField on ConfigurableProduct {
      configurable_options {
        attribute_code
        position
      }
      configurable_product_options_selection {
        __typename
        configurable_options {
          attribute_code
          label
          uid
          values {
            __typename
            uid
            label
            is_use_default
            is_available
            swatch {
              ...SwatchDataField
            }
          }
        }
      }
      variants {
        attributes {
          code
          label
          uid
          value_index
        }
        product {
          __typename
          special_price
          ...CustomField
          price_range {
            ...PriceRangeField
          }
          sku
          name
          url_key
          image {
            url
            label
          }
          small_image {
            url
            label
          }
          thumbnail {
            url
            position
          }
          uid
        }
      }
    }
    fragment SwatchDataField on SwatchDataInterface {
      __typename
      ... on ColorSwatchData {
        __typename
        value
      }
      ... on ImageSwatchData {
        __typename
        value
      }
      ... on TextSwatchData {
        __typename
        value
      }
    }
  fragment PriceRangeField on PriceRange {
    __typename
    maximum_price {
      ...ProductPriceField
    }
    minimum_price {
      ...ProductPriceField
    }
  }
  fragment ProductPriceField on ProductPrice {
    discount {
      amount_off
      percent_off
    }
    final_price {
      currency
      value
    }
    regular_price {
      currency
      value
    }
  }
   
`
export const GET_LIST_CATEGORIES = `
query getCategories($filters: CategoryFilterInput) {
  categories(filters: $filters) {
    __typename
    items {
      breadcrumbs {
        ...BreadcrumbFields
      }
      children {
        breadcrumbs {
          ...BreadcrumbFields
        }
        children{
          breadcrumbs{
              ...BreadcrumbFields
          }
          children{
            breadcrumbs{
                ...BreadcrumbFields
            }
            ...CategoryTreeFields
          }
            ...CategoryTreeFields
        }
        ...CategoryTreeFields
      }
      ...CategoryTreeFields
    }
  }
}
fragment CategoryTreeFields on CategoryTree {
  uid
  available_sort_by
  canonical_url
  name
  image
  include_in_menu
  meta_description
  meta_keywords
  meta_title
  display_mode
  url_key
  url_path
  description
  path
  path_in_store
  children_count
  position
}
fragment BreadcrumbFields on Breadcrumb {
  category_level
  category_name
  category_uid
  category_url_key
  category_url_path
}
`
export const GET_DETAIL_PRODUCT = `
query getProductDetail($filter: ProductAttributeFilterInput) {
  products(filter: $filter) {
    items {
      ...ProductInterfaceField
      ...ConfigurableProductField
      related_products {
        ...ProductInterfaceField
      }
      upsell_products {
        ...ProductInterfaceField
      }
    }
    total_count
  }
}
fragment ProductInterfaceField on ProductInterface {
  __typename
  sku
  name
  uid
  url_key
  url_suffix
  canonical_url
  categories {
    __typename
    name
    url_key
    url_path
    level
    uid
    icon_image
    image
    path
  }
  meta_description
  meta_keyword
  meta_title
  new_from_date
  new_to_date
  description {
    html
  }
  rating_summary
  review_count
  short_description {
    html
  }
  thumbnail {
    url
    position
  }
  image {
    url
  }
  media_gallery {
    __typename
    disabled
    label
    url
    position
  }
  price_range {
    ...PriceRangeField
  }
  ...CustomField
}
fragment ConfigurableProductField on ConfigurableProduct {
  configurable_options {
    attribute_code
    attribute_uid
    label
    position
    uid
    use_default
  }
  configurable_product_options_selection {
    __typename
    configurable_options {
      attribute_code
      label
      uid
      values {
        __typename
        uid
        label
        is_use_default
        is_available
        swatch {
          ...SwatchDataField
        }
      }
    }
  }
  variants {
    attributes {
      code
      label
      uid
      value_index
    }
    product {
      __typename
      special_price
      ...CustomField
      price_range {
        ...PriceRangeField
      }
      sku
      name
      url_key
      image {
        url
        label
      }
      small_image {
        url
        label
      }
      thumbnail {
        url
        position
      }
    }
  }
}
fragment SwatchDataField on SwatchDataInterface {
  __typename
  ... on ColorSwatchData {
    __typename
    value
  }
  ... on ImageSwatchData {
    __typename
    value
  }
  ... on TextSwatchData {
    __typename
    value
  }
}
fragment CustomField on ProductInterface {
  color
  
  size
 
  country_of_manufacture
  daily_sale {
    end_date
    entity_id
    sale_price
    sale_qty
    saleable_qty
    sold_qty
    start_date
    __typename
  }
  rating_summary_start {
    star_1
    star_2
    star_3
    star_4
    star_5
  }
  attributes {
    attribute_code
    label
    value
  }
}
fragment PriceRangeField on PriceRange {
  __typename
  maximum_price {
    ...ProductPriceField
  }
  minimum_price {
    ...ProductPriceField
  }
}
fragment ProductPriceField on ProductPrice {
  discount {
    amount_off
    percent_off
  }
  final_price {
    currency
    value
  }
  regular_price {
    currency
    value
  }
}
`
export const GET_REVIEWS = `
query getReviewsProduct($filter: ProductAttributeFilterInput, $pageSize: Int, $currentPage: Int) {
  products(filter: $filter) {
    items {
      reviews(pageSize: $pageSize, currentPage: $currentPage) {
        items {
          average_rating
          created_at
          nickname
          ratings_breakdown {
            name
            value
          }
          summary
          text
        }
        page_info {
          current_page
          page_size
          total_pages
        }
      }
    }
  }
}
`
export const GET_PRODUCT_REVIEWS_METADATA = `
query productReviewRatingsMetadata {
  productReviewRatingsMetadata {
    items {
      id
      name
      values {
        value
        value_id
      }
    }
  }
}
`
//field in CREATE_REVIEW
// product {
//   sku
//   url_key
//   name
// }
export const CREATE_REVIEW = `
mutation CreateComprehensiveReview($input: CreateReviewInput!) {
  createProductReview(input: $input) {
    review_id
    product_id
    rating
    title
    author_name
    content
    status
    media {
      type
      url
      thumbnail
    }
    created_at
  }
}`

export const fetchProducts = async (params: IOptionsProductProps, query = GET_LIST_PRODUCTS) => {
  const { filter = {}, pageSize = PAGE_SIZE, currentPage = 1, search = '', sort = {} } = params
  try {
    const fetchProducts: IProducts = await fetcher
      .get(
        buildQuery(query, {
          filter,
          pageSize,
          currentPage,
          search,
          sort,
        }),
        {
          next: { revalidate: 300, tags: [`${JSON.stringify(params)}`] },
          cache: 'force-cache',
        }
      )
      .then((res) => {
        return res?.payload?.data?.products
      })
    return fetchProducts
  } catch (err) {
    console.log(err)
  }
}
export const fetchCategories = async () => {
  try {
    const fetchCategories: ICategories = await fetcher
      .get(buildQuery(GET_LIST_CATEGORIES), {
        next: { revalidate: 300, tags: ['category-list'] },
      })
      .then((res) => res?.payload?.data?.categories)
    return fetchCategories
  } catch (err) {
    console.log(err)
    return null
  }
}

export const fetchDetailProduct = async (url_key: string) => {
  try {
    const fetchProducts = await fetcher
      .get(
        buildQuery(GET_DETAIL_PRODUCT, {
          filter: {
            url_key: {
              eq: url_key,
            },
          },
        }),
        {
          next: {
            revalidate: 300,
            tags: [url_key],
          },
        }
      )
      .then((res) => {
        return res?.payload?.data?.products
      })
    return fetchProducts
  } catch (err) {
    console.log(err)
    return null
  }
}

export const getProductReviewsMetadata = async () => {
  try {
    const response = await fetcher
      .post(
        '',
        {
          query: GET_PRODUCT_REVIEWS_METADATA,
        },
        {
          next: { revalidate: 300, tags: ['product-reviews-metadata'] },
        }
      )
      .then((res) => res)
    const list = response?.payload?.data?.productReviewRatingsMetadata
    if (!list) return { data: null, message: response?.payload?.errors?.[0]?.message, status: 'error' }
    return list
  } catch (err) {
    console.log(err)
    return { data: null, message: JSON.stringify(err), status: 'error' }
  }
}

export const getListReviews = async ({
  url_key,
  pageSize = 20,
  currentPage = 1,
}: {
  url_key: string
  pageSize?: number
  currentPage?: number
}) => {
  try {
    const response = await fetcher
      .post(
        '',
        {
          query: GET_REVIEWS,
          variables: {
            filter: {
              url_key: {
                eq: url_key,
              },
            },
            pageSize: pageSize,
            currentPage: currentPage,
          },
        },
        {
          next: { revalidate: 300, tags: ['product-reviews', url_key] },
        }
      )
      .then((res) => res?.payload)
    const list = response?.data?.products?.items
    if (!list) return { data: null, message: response?.errors?.[0]?.message, status: 'error' }
    return list
  } catch (err) {
    console.log(err)
    return { data: null, message: JSON.stringify(err), status: 'error' }
  }
}

export const createReview = async ({
  nickname,
  sku,
  summary,
  text,
  ratings,
}: {
  nickname: string
  sku: string
  summary: string
  text: string
  ratings: { id: string; value_id: string }[]
}) => {
  try {
    const response = await fetchWithToken({
      query: CREATE_REVIEW,
      variables: {
        input: {
          nickname: nickname,
          sku: sku,
          summary: summary,
          text: text,
          ratings: ratings,
        },
      },
    })
    const data = response?.payload?.data?.createProductReview
    if (!data || response?.payload?.errors?.length > 0)
      return { data: null, message: response?.payload?.errors?.[0]?.message, status: 'error' }
    return data
  } catch (err) {
    console.log(err)
    return { data: null, message: JSON.stringify(err), status: 'error' }
  }
}

/**
 * Tạo đánh giá sản phẩm với media (hình ảnh, video)
 */
export const createComprehensiveReview = async (input: ICreateReviewInput) => {
  try {
    const response = await fetchWithToken({
      query: CREATE_REVIEW,
      variables: { input },
    })

    const data: ICreateReviewResponse = response?.payload?.data?.createProductReview
    if (response?.payload?.errors?.length > 0) {
      return {
        status: 'error' as const,
        message: response.payload.errors[0]?.message || 'Có lỗi xảy ra khi tạo đánh giá',
        data: null,
      }
    }

    return {
      status: 'success' as const,
      message: 'Đánh giá của bạn đã được gửi thành công!',
      data,
    }
  } catch (err) {
    console.error('Error creating review:', err)
    return {
      status: 'error' as const,
      message: 'Có lỗi xảy ra khi gửi đánh giá',
      data: null,
    }
  }
}
